import makeRequest from "api/makeRequest";
import { RequstMethods } from "api/requestMethode";
import url from "api/urls";

export class ExamGroupService {
    static async getAllExamGroups() {
        return await makeRequest(url.examGroup.getAllExamGroups, RequstMethods.GET);
    }

    static async getExamGroupById(id: any) {
        return await makeRequest(url.examGroup.getExamGroupById + "/" + id, RequstMethods.GET);
    }

    static async getAllExamsInGroup(id: any) {
        return await makeRequest(url.examGroup.getAllExamsInGroup + "/" + id + "/exams" , RequstMethods.GET);
    }

    static async createExamGroup(data: any) {
        return await makeRequest(url.examGroup.createExamGroup, RequstMethods.POST, data);
    }

    static async addExamToGroup(data: any, examId: any) {
        return await makeRequest(url.examGroup.addExamToGroup + "/" + examId + "/exam", RequstMethods.POST, data);
    }

    static async updateExamGroup(data: any, id: any) {
        return await makeRequest(url.examGroup.updateExamGroup + "/" + id, RequstMethods.PUT, data);
    }

    static async deleteExamGroup(id: any) {
        return await makeRequest(url.examGroup.deleteExamGroup + "/" + id, RequstMethods.DELETE);
    }

    static async removeExamFromGroup(examId: any) {
        return await makeRequest(url.examGroup.removeExamFromGroup + "/" + examId, RequstMethods.DELETE);
    }
}